import { InvoiceStatus } from "@wingspanhq/payments/dist/interfaces";
import { WSQueryCache } from "@ws-react-query";
import {
  BulkActionOnProgress,
  BulkActionProgress,
  bulkActionFactory,
  useForegroundBulkAction
} from "../../../modules/BulkActions";
import { QUERY_PAYABLE, QUERY_PAYABLES } from "../../../query/payments/keys";
import { paymentsService } from "../../../services/payments";
import { PayablesTableItemData } from "./PayablesTable";

function processOpenPayables(
  data: PayablesTableItemData[],
  onProgress: BulkActionOnProgress,
  onSuccess?: () => void
): Promise<BulkActionProgress> {
  const bulkAction = bulkActionFactory<PayablesTableItemData>({
    onProgress,
    action: async item => {
      const payableId = item.payable?.payableId || "";

      return await paymentsService.payable.update(payableId, {
        status: InvoiceStatus.Open
      });
    },
    onFinish: ({ successItems }) => {
      WSQueryCache.invalidateQueries(QUERY_PAYABLES);
      successItems.forEach(item => {
        WSQueryCache.invalidateQueries([
          QUERY_PAYABLE,
          item.payable?.payableId
        ]);
      });
      onSuccess?.();
    }
  });

  return bulkAction.run(data).then(({ successItems, failedItems }) => ({
    total: data.length,
    processed: successItems.length + failedItems.length,
    successful: successItems.length,
    failed: failedItems.length
  }));
}

export function useBulkOpenPayables() {
  const runBulkAction = useForegroundBulkAction();

  return (items: PayablesTableItemData[], onSuccess?: () => void) =>
    runBulkAction({
      actionName: "Open payables",
      itemCount: items.length,
      confirmDescription: "Open selected draft payables",
      confirmLabel: "Open",
      prepare: async () => items,
      process: async (data, onProgress) =>
        processOpenPayables(data, onProgress, onSuccess)
    });
}
